<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <path
      d="M61.5 27L69 38L54.5 71.5L38 75.5L21 62L19 46L24 35.5L31.5 28.5L49 24L61.5 27Z"
      fill="white"
    />
    <path d="M72.5 69.5L76 66.5L80 70.5L77.1429 74L72.5 69.5Z" fill="white" />
    <path
      d="M24.4914 34.0962L19.2502 45.9162"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.2857 70.4792L21.9333 62.4386"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.7034 54.0631L25.313 55.6243"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.2255 27.5607L48.7047 24.2649"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M68.782 37.9889L63.7792 30.0784"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.1517 34.5305L36.211 67.4295"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M56.2341 31.5647L54.7723 37.0502"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.9905 33.2136L43.8329 46.2757"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M51.5405 71.6779L42.5 73.9999"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.6522 49.5075L50.7909 28.3359"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M48 22C48 24.6522 49.0536 27.1957 50.9289 29.0711C52.8043 30.9464 55.3478 32 58 32C60.6522 32 63.1957 30.9464 65.0711 29.0711C66.9464 27.1957 68 24.6522 68 22C68 19.3478 66.9464 16.8043 65.0711 14.9289C63.1957 13.0536 60.6522 12 58 12C55.3478 12 52.8043 13.0536 50.9289 14.9289C49.0536 16.8043 48 19.3478 48 22Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 55C7 57.6522 8.05357 60.1957 9.92893 62.0711C11.8043 63.9464 14.3478 65 17 65C19.6522 65 22.1957 63.9464 24.0711 62.0711C25.9464 60.1957 27 57.6522 27 55C27 52.3478 25.9464 49.8043 24.0711 47.9289C22.1957 46.0536 19.6522 45 17 45C14.3478 45 11.8043 46.0536 9.92893 47.9289C8.05357 49.8043 7 52.3478 7 55Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M76.0276 66.0239L80.2257 70.223"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M76.658 73.7907L72.5781 69.7118"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M93.2484 86.6419L93.0779 86.8124C92.3888 87.4963 91.4573 87.88 90.4864 87.88C89.5155 87.88 88.584 87.4963 87.8949 86.8124L76.6275 75.5489C76.3997 75.319 76.272 75.0086 76.272 74.685C76.272 74.3615 76.3997 74.051 76.6275 73.8212L80.2533 70.1924C80.483 69.9645 80.7935 69.8365 81.1171 69.8365C81.4407 69.8365 81.7512 69.9645 81.9809 70.1924L93.2484 81.4618C93.5889 81.8017 93.8591 82.2054 94.0435 82.6499C94.2278 83.0943 94.3227 83.5707 94.3227 84.0519C94.3227 84.533 94.2278 85.0095 94.0435 85.4539C93.8591 85.8983 93.5889 86.3021 93.2484 86.6419Z"
      fill="#211F58"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M44.4586 64.9354C47.0783 69.2164 51.2913 72.2813 56.1708 73.456C61.0503 74.6307 66.1966 73.819 70.4776 71.1993C74.7585 68.5796 77.8235 64.3666 78.9982 59.4871C80.1729 54.6076 79.3611 49.4613 76.7414 45.1803C75.4443 43.0606 73.7424 41.2171 71.7328 39.7552C69.7232 38.2932 67.4453 37.2413 65.0293 36.6597C62.6132 36.078 60.1062 35.9779 57.6514 36.3652C55.1967 36.7524 52.8422 37.6193 50.7225 38.9164C48.6028 40.2136 46.7593 41.9155 45.2973 43.9251C43.8354 45.9347 42.7835 48.2125 42.2019 50.6286C41.0271 55.5081 41.8389 60.6544 44.4586 64.9354Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.3055 44.353C73.4229 46.4703 74.8648 49.1679 75.449 52.1047C76.0332 55.0415 75.7335 58.0855 74.5876 60.8519C73.4418 63.6184 71.5013 65.9829 69.0116 67.6464C66.5219 69.31 63.5948 70.1979 60.6005 70.1979C57.6062 70.1979 54.6791 69.31 52.1894 67.6464C49.6997 65.9829 47.7593 63.6184 46.6134 60.8519C45.4676 58.0855 45.1678 55.0415 45.752 52.1047C46.3362 49.1679 47.7782 46.4703 49.8955 44.353C51.3012 42.9471 52.9701 41.8317 54.8069 41.0708C56.6437 40.3099 58.6124 39.9182 60.6005 39.9182C62.5887 39.9182 64.5574 40.3099 66.3941 41.0708C68.2309 41.8317 69.8998 42.9471 71.3055 44.353Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 30C21 30.7879 21.1552 31.5681 21.4567 32.2961C21.7583 33.0241 22.2002 33.6855 22.7574 34.2426C23.3145 34.7998 23.9759 35.2417 24.7039 35.5433C25.4319 35.8448 26.2121 36 27 36C27.7879 36 28.5681 35.8448 29.2961 35.5433C30.0241 35.2417 30.6855 34.7998 31.2426 34.2426C31.7998 33.6855 32.2417 33.0241 32.5433 32.2961C32.8448 31.5681 33 30.7879 33 30C33 29.2121 32.8448 28.4319 32.5433 27.7039C32.2417 26.9759 31.7998 26.3145 31.2426 25.7574C30.6855 25.2002 30.0241 24.7583 29.2961 24.4567C28.5681 24.1552 27.7879 24 27 24C26.2121 24 25.4319 24.1552 24.7039 24.4567C23.9759 24.7583 23.3145 25.2002 22.7574 25.7574C22.2002 26.3145 21.7583 26.9759 21.4567 27.7039C21.1552 28.4319 21 29.2121 21 30Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31 73C31 73.7879 31.1552 74.5681 31.4567 75.2961C31.7583 76.0241 32.2002 76.6855 32.7574 77.2426C33.3145 77.7998 33.9759 78.2417 34.7039 78.5433C35.4319 78.8448 36.2121 79 37 79C37.7879 79 38.5681 78.8448 39.2961 78.5433C40.0241 78.2417 40.6855 77.7998 41.2426 77.2426C41.7998 76.6855 42.2417 76.0241 42.5433 75.2961C42.8448 74.5681 43 73.7879 43 73C43 72.2121 42.8448 71.4319 42.5433 70.7039C42.2417 69.9759 41.7998 69.3145 41.2426 68.7574C40.6855 68.2002 40.0241 67.7583 39.2961 67.4567C38.5681 67.1552 37.7879 67 37 67C36.2121 67 35.4319 67.1552 34.7039 67.4567C33.9759 67.7583 33.3145 68.2002 32.7574 68.7574C32.2002 69.3145 31.7583 69.9759 31.4567 70.7039C31.1552 71.4319 31 72.2121 31 73Z"
      fill="#E4F1FF"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="58"
      cy="22"
      r="3.75"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="17"
      cy="55"
      r="3.75"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="27"
      cy="30"
      r="1.75"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="37"
      cy="73"
      r="1.75"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
